import { Truncate as PrimerTruncate, TruncateProps as PrimerTruncateProps } from '@primer/react';

type Props = {} & PrimerTruncateProps;

const Truncate = ({ ...props }: Props) => <PrimerTruncate {...props} />;

export default Truncate;
export type { Props as TruncateProps };
